import { apiClient } from '../api';
import type { ApiResponse } from '@/types/auth';
import type { AdminVerificationPricingResponse, AdminVerificationPricingRow } from '@/types/verification';

export interface UpdateVerificationPricingPayload {
  providerCost?: number;
  subscriberPrice?: number;
  agentPrice?: number;
  isActive?: boolean;
  description?: string | null;
}

class AdminVerificationService {
  listPricing() {
    return apiClient.get<ApiResponse<AdminVerificationPricingResponse>>('/admins/verification/pricing');
  }

  updatePricing(id: number, payload: UpdateVerificationPricingPayload) {
    return apiClient.put<ApiResponse<{ pricing: AdminVerificationPricingRow }>>(
      `/admins/verification/pricing/${id}`,
      payload,
    );
  }
}

export const adminVerificationService = new AdminVerificationService();
